import { useMutation } from "react-query";
import getFhDocument from "../services/getFhDocument";

const useGetFhDocument = () => {
  return useMutation(["get-fh-document"], getFhDocument);
};

export default useGetFhDocument;
